<template>
  <article>
    <h3 v-html="title" v-if="title" />
    <slot />
  </article>
</template>

<script>
export default {
  name: 'Article',
  props: ['title']
};
</script>
